import baseRoute from '../baseRoute';

export default `${baseRoute}/fieldReport` as const;
